import React, { useEffect, useState } from "react";
import s from "./style.module.scss";
import { IStatus } from "entities/Account/api/models";
import { statusesApi } from "entities/Account/api";
import { Item } from "./Item";

export const StatusesContent: React.FC = () => {
  const [statuses, setStatuses] = useState<IStatus[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    statusesApi()
      .then(setStatuses)
      .catch(console.log)
      .finally(() => setLoading(false));
  }, []);

  return (
    <ul className={s.content}>
      {statuses.map((item) => (
        <Item {...item} key={item.id} />
      ))}
    </ul>
  );
};
